import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { TimeRangeComponent } from './time-range.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [TimeRangeComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NzTimePickerModule
    ],
    exports: [TimeRangeComponent]
})
export class TimeRangeModule {
}
